import React from 'react';
import { Button, Typography } from '@/ui-kit';
import styles from './intro.module.scss';
import commonIntroStyles from './intro.module.css';
import { routesApp } from '@/constans/routes';
import { generatePath, useNavigate } from 'react-router-dom';
import { LogoTravelask } from '@/assets/icons';
import { useAuth } from '@/store/useAuth';
import BgImg from '@/assets/images/intro.png';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { SignUpDesign, useSignUpDesign } from '@/store/useSignUpDesign';
import { useIntroRedirects } from './useIntroRedirects';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';
import { Trans, useTranslation } from 'react-i18next';
import { LangSelector } from '../lang-selector/lang-selector';

export const Intro: React.FC = () => {
    const { user } = useAuth((state) => state);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const {
        design: signUpScreen,
        setDesign
    } =
        useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    useIntroRedirects('default')

    const { isVibrationEnabled } =
        useVibration(state => state);

    const registerClick = () => {
        callYaMetrika('clicked_registration_button');
        navigate(
            generateSignUpPath()
        );
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    return (
        <section className={styles.intro}>
            <div className={styles.intro__deckor}>
                <img
                    className={styles.intro__deckor__img}
                    src={BgImg}
                    alt="background"
                />
            </div>
            <div className={styles.intro__content}>
                <Typography
                    className={styles.intro__Headline}
                    typeColor="white"
                    variant="h1"
                    center>
                    <Trans i18nKey="registration.dating_for_those_who_love_to_travel_together_secondary" />
                </Typography>
                <div className={styles.logoTravelask}>
                    <Typography
                        fontWeight="bold"
                        typeColor="black"
                        className={styles.labelLogo}>
                        by
                    </Typography>
                    <LogoTravelask
                        width={142}
                        height={28}
                        className={styles.labelLogoImg} />
                </div>
                <Typography
                    typeColor="white"
                    variant="p"
                    className={styles.intro__text}
                    center>
                    <Trans i18nKey="registration.intro_subtitle" />
                </Typography>
                <div className={styles.intro__btn}>
                    <Button
                        variant="stretched"
                        onClick={registerClick}>
                        {t('registration.signup')}
                    </Button>
                </div>
                <Typography center className={styles.introFootnote}>
                    {t('registration.i_accept_the_user_registration_terms')}
                </Typography>
                <Typography center className={styles.introFootnote}>
                    {t('registration.i_agree_with_terms.intro_base')}
                </Typography>
            </div>
            <LangSelector className={commonIntroStyles.langSelector} />
        </section>
    );
};
